var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { REACT_APP__URL_DATAFAN_BASE } from "@smp/utils";
import { apiDatafanHandleTokenRefresh, getDatafanToken, refreshDatafanToken, } from "../_helpers";
export const ApiDatafanSootherAuth = {
    get: () => __awaiter(void 0, void 0, void 0, function* () {
        return apiDatafanHandleTokenRefresh(() => __awaiter(void 0, void 0, void 0, function* () {
            return fetch(`${REACT_APP__URL_DATAFAN_BASE}/api/0/soother-auth/`, {
                headers: {
                    accept: "application/json",
                    authorization: `JWT ${yield (getDatafanToken() ||
                        refreshDatafanToken())}`,
                },
            }).then((response) => response.headers.get("x-smp-jwt") || undefined);
        }));
    }),
};
//# sourceMappingURL=soother_auth.js.map